// 当前任务状态,0 获取文件信息（如计算gcid）,1开始上传，2完成,-1失败,-2暂停,-3排队中

export default {
  // 本地上传文件状态
  UPLOAD_GET_INFO: 0,
  UPLOAD_START: 1,
  UPLOAD_DONE: 2,
  UPLOAD_FAIL: -1,
  UPLOAD_PAUSE: -2,
  UPLOAD_WAIT: -3,

  // VIP弹窗提示状态
  NO_VIP_DIALOG_QUANTITY_LIMIT: 1, // 【非会员】文件数量超限
  NO_VIP_DIALOG_FILE_SIZE_LIMIT: 2, // 【非会员】文件大小超限
  VIP_DIALOG_QUANTITY_LIMIT: 3, // 【会员（包括白金会员和超级会员）】状态下文件数量超限
  VIP_DIALOG_FILE_SIZE_LIMIT: 4, // 【白金会员】文件大小超限
  SUPER_VIP_DIALOG_FILE_SIZE_LIMIT: 5, // 【超级会员】文件大小超限

  // 上传类型
  UPLOAD_TYPE_FORM: 'UPLOAD_TYPE_FORM',
  UPLOAD_TYPE_RESUMABLE: 'UPLOAD_TYPE_RESUMABLE',
  UPLOAD_TYPE_UNKNOWN: 'UPLOAD_TYPE_UNKNOWN',

  // 跳转地址
  YINGYONGBAK_SHARE_DOWNLOAD_URL:
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.xunlei.downloadprovider&ckey=CK1470052035866',
  YINGYONGBAK_HOMEPAGE_DOWNLOAD_URL:
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.xunlei.downloadprovider&ckey=CK1470051932665',
  TASK_CREATE_COUNT_LIMIT: 'task_create_count_limit', // 任务创建次数达到上限
  NOTE_GUIDE_TIP_STATUS: 'noteGuideTipStatus', // 云笔记新手引导
  CREATE_URLTASK_TIP_TIME: 'create_urltask_tip_time', // 最新关闭云添加次数活动banner的时间
}

export const videoTypes = [
  'rmvb',
  '3gp',
  'mkv',
  'mp4',
  'flv',
  'avi',
  'wmv',
  'rm',
  'mpg',
  'ts',
  'mov',
  'xv',
  'asf',
  'f4v',
  'm4v',
  'mpeg',
  'rmv',
  'ram',
  'm2ts',
]
export const audioTypes = [
  'mp3',
  'wma',
  'ape',
  'aac',
  'acc',
  'wav',
  'pcm',
  'ogg',
  'mid',
  'flac',
  'm4a',
  'aiff',
  'amr',
  'cda',
  'vqf',
]
export const documentTypes = ['txt', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'ppt', 'pptx']
export const cloudAppTypes = ['txt', 'pdf']
export const compressedTypes = ['zip', 'rar', '7z', 'tar', 'gzip', 'bz', 'bz2', 'jar']
export const imageTypes = ['png', 'jpg', 'jpeg', 'gif', 'bmp']
export const appTypes = ['ipa', 'apk', 'dmg', 'exe', 'ipsw']

export const exts = [...videoTypes, ...audioTypes, ...documentTypes, ...compressedTypes, ...imageTypes, ...appTypes]

// 视频播放倍速
export const speedList = [
  {
    name: '0.5x',
    value: 0.5,
    type: '',
  },
  {
    name: '0.75x',
    value: 0.75,
    type: '',
  },
  {
    name: '1.0x',
    value: 1.0,
    type: '',
  },
  {
    name: '1.25x',
    value: 1.25,
    type: 'vip',
  },
  {
    name: '1.5x',
    value: 1.5,
    type: 'vip',
  },
  {
    name: '1.75x',
    value: 1.75,
    type: 'vip',
  },
  {
    name: '2.0x',
    value: 2.0,
    type: 'vip',
  },
]

export const TSPlayerLibUrl = '//pan.xunlei.com/ts-player.js'
export const IFolderType = 'drive#folder'
export const IFileType = 'drive#file'
export const MAC_PAN_URL = 'xunleiapp://mac.thunder/openTab?tabId=com.xunlei.plugin.page.cloudspace'
export const PAN_SAFE_RED = 'panSafeFirstReddotShow'
export const PAN_SAFE_GUIDE = 'SafeWelcomeShowUids_'
export const SAFE_FOLDER_TYPE = 'SAFE'
export const SAFE_SPACE_TYPE = 'SPACE_SAFE'
export const COMPRESS__SUFFIX = ['.7z', '.zip', '.rar']

// 解压相关接口状态
export const DECOMPRESS_OK = 'OK' // 正常
export const DECOMPRESS_PASS_WORD_EMPTY = 'PASS_WORD_EMPTY' // 需要输入解压密码
export const DECOMPRESS_PASS_WORD_ERROR = 'PASS_WORD_ERROR' // 解压密码错误
export const DECOMPRESS_RUNNING_TASK = 'RUNNING_TASK' // 有解压中的任务在执行
export const DECOMPRESS_EXPIRED = 'EXPIRED' // 已过期
export const DECOMPRESS_DELETED = 'DELETED' // 已删除
export const DECOMPRESS_SENSITIVE_RESOURCE = 'SENSITIVE_RESOURCE' // 包含敏感资源
export const DECOMPRESS_SENSITIVE_WORD = 'SENSITIVE_WORD' // 文件名包含敏感词
export const DECOMPRESS_AUDITING = 'AUDITING' // 审核中
export const DECOMPRESS_NOT_FOUND = 'NOT_FOUND' // 未找到
export const DECOMPRESS_INVALID_FILE_FORMAT = 'INVALID_FILE_FORMAT' // 非法压缩包
export const PHASE_TYPE_ERROR = 'PHASE_TYPE_ERROR' // 解压失败
export const FILE_SPACE_NOT_ENOUGH = 'file_space_not_enough' // 空间容量不足
export const DECOMPRESS_NEED_MORE_QUOTA = 'NEED_MORE_QUOTA' // 解压权限不足
export const ONE_GB = 1024 * 1024 * 1024 // 1GB大小
export const MONTHLY_UPLOAD_SIZE_EXCEEDED = 'monthly_upload_size_exceeded' // 每月上传流量超限
export const DAILY_UPLOAD_SIZE_EXCEEDED = 'daily_upload_size_exceeded' // 每日上传流量超限
